module.exports = __webpack_public_path__ + "img/TH_banner_Anuja_Mehra.41c06ce3.jpg";